import * as DATAELEMENTS from '../constants/custom-data-elements';
import OrchCustomData from '../helpers/orch-custom-data';

/**
 * resetCustomData is needed to reset the cached data from Orchestration
 * @param {string} type
 */
export default function resetCustomData(type) {
  const supportedNetworks = OrchCustomData.srcSdks.appConfig.supportedNetworks;
  switch (type) {
    case DATAELEMENTS.IS_RECOGNIZED:
      if (supportedNetworks && supportedNetworks.length >= 1) {
        supportedNetworks.forEach(dcf => {
          if (OrchCustomData.srcSdks.apiResponseCache.isRecognized[dcf]) {
            OrchCustomData.srcSdks.apiResponseCache.isRecognized[dcf].recognized = false;
          }
        });
      }
      const isRecognizedPromises = OrchCustomData.srcSdks.isRecognizedPromiseArr;
      // reset the cached data except usedDevice flag
      Promise.all(isRecognizedPromises).then(responses => {
        for (const res of responses) {
          res.recognized = false;
          if (res?.customData) {
            res.customData = {};
          }
          if (res?.idTokens) {
            res.idTokens = [];
          }
        }
      });
      break;
  }
}
